import { BORROW_FEE_FACTORIES } from "impermax-sdk";
import React from "react";
import { Row, Col } from "react-bootstrap";
import useFactory from "../../../hooks/useFactory";
import { formatFloat } from "../../../utils/format";

export interface BorrowFeeProps {
  amount: number;
  symbol: string;
}

export default function BorrowFee({ amount, symbol }: BorrowFeeProps) {
  const factory = useFactory();
  if (!BORROW_FEE_FACTORIES.includes(factory)) return (null);
  return (
    <Row>
      <Col xs={6}>Borrow Fee:</Col>
      <Col xs={6} className="text-right">{formatFloat(amount / 1000)} {symbol}</Col>
    </Row>
  );
}